import * as React from 'react';

export type SystemTotalProps = {
  total: number
}

export default function SystemTotal(props: SystemTotalProps): React.ReactElement {
  const totalAsDollars = props.total;


  return(<div className="pb-4 flex flex-row justify-between">
    <div className="basis-2/3">
    <h3 className="text-2xl font-bold">TOTAL</h3>
    </div>
    <div className="basis-1/3">
      <h3 className="text-2xl font-bold text-right">${totalAsDollars.toLocaleString()}</h3>
    </div>
  </div>);
}
